<template>
    <div>
        <img src='https://mpicture.iartschool.com/businessLicense.jpg'/>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>